export default function (http) {
    return {

        /*************************产品管理接口开始***********************/
        queryByPage (data){
            return http.json({
                url: '/order/and/send/item/query',
                data
            });
        },

        queryPassItems(data){
            return http.json({
                url: '/order/and/send/item/queryPassItems',
                data
            });
        },
        getInfo (data){
            return http.json({
                url: `/order/and/send/item/get?id=${data.id}`,
                data
            })
        },
        queryAll (data){
            return http.json({
                url: '/order/and/send/item/queryAll',
                data
            })
        },
        saveInfo (data){
            return http.json({
                url: `/order/and/send/item/saveBatch`,
                data
            })
        },
        delete (data){
            return http.json({
                url: `/order/and/send/item/delete`,
                data
            })
        },
        /** ***********************产品管理接口结束***********************/

    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/orderAddSendItem.js